import React from 'react';
import { CompanyPhoneNumber, ContactEmailAddress } from '../../utils/Constants';

function MainContainerContent({ title, subtitle, paraOne, paraTwo, images }) {
  return (
    <section className='grid w-full pb-8'>
      <div className='grid w-full gap-6 '>
        {/* Text Content */}
        <section className='grid text-center px-6 py-8 sm:px-8 md:px-12 lg:container lg:mx-auto lg:max-w-[60vw]'>
          <div className='grid'>
            <div className='grid gap-2'>
              <h3 className='text-4xl lg:text-5xl text-colour6 dark:text-colour6 font-StencilW01'>
                {title}
              </h3>
              <h4 className='text-xl lg:text-2xl text-gray-600 dark:text-colour1 font-StencilW01 mt-2'>
                {subtitle}
              </h4>
            </div>
            <div className='grid gap-2'>
              <p className='mt-4 text-lg'>{paraOne}</p>
              <p className='mt-2 text-lg'>{paraTwo}</p>
            </div>
          </div>
        </section>

        {/* Image Grid */}
        <section className='grid grid-cols-2 lg:gap-4 lg:grid-cols-4 lg:container lg:mx-auto lg:max-w-[60vw]'>
          {images.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`${index + 1}`}
              className='w-full h-full object-cover lg:rounded-lg lg:shadow-md'
            />
          ))}
        </section>

        <section className='grid gap-4 h-fit py-2'>
          <div className='grid px-6 sm:px-8 md:px-12 lg:container lg:mx-auto lg:max-w-[60vw]'>
            <a
              href={CompanyPhoneNumber}
              className={`flex items-center gap-3 cursor-pointer bg-colour1 dark:bg-colour1 border-2 border-solid border-colour5 hover:bg-colour2 dark:hover:bg-colour2 px-6 py-4 w-full text-center text-colour5 dark:text-colour5 hover:text-colour5 dark:hover:text-colour5`}
              aria-label={`Book now button`}
              target='_blank'
              rel='noopener noreferrer'
            >
              <span className='text-2xl'></span>
              <div className='text-center w-full text-2xl font-meduim font-StencilW01 tracking-wider'>
                <span>Call Now</span>
              </div>
            </a>
          </div>
          <div className='grid px-6 sm:px-8 md:px-12 lg:container lg:mx-auto lg:max-w-[60vw] overflow-hidden'>
            <a
              href={`mailto:${ContactEmailAddress}`}
              className={`flex items-center gap-3 cursor-pointer bg-colour1 dark:bg-colour1  border-2 border-solid border-colour5 hover:bg-colour2 dark:hover:bg-colour2 px-6 py-4 w-full text-center text-colour5 dark:text-colour5 hover:text-colour5 dark:hover:text-colour5`}
              aria-label={`Email now button`}
            >
              <span className='text-2xl'></span>
              <div className='text-center w-full text-2xl font-medium font-StencilW01 tracking-wider'>
                <span className='hidden lg:grid'>{ContactEmailAddress}</span>
                <span className='lg:hidden'>Email Now</span>
              </div>
            </a>
          </div>
        </section>
      </div>
    </section>
  );
}

export default MainContainerContent;
